import { Map } from "immutable";
import { resolveEach } from "redux-resolver";
import {
  createAttachmentReducer,
  attachmentsInitialState
} from "MODULES/shared/reducer";
import resourceTypes from "MODULES/shared/types/resourceTypes";
import * as actionTypes from "./actionTypes";

const initialState = Map({
  shipment: Map()
}).merge(attachmentsInitialState);

function setShipment(state, action) {
  return state.merge({ shipment: action.shipment });
}

export default resolveEach(initialState, {
  ...createAttachmentReducer(resourceTypes.shipment),
  [actionTypes.SET]: setShipment
});



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/reducer.js